export default __webpack_public_path__ + "static/media/sqft.c7f76cf1.svg";